module.exports = __webpack_public_path__ + "static/media/Overview_Deselected.a49eb57c.svg";